module.exports = __webpack_public_path__ + "media/images/primary_previous_page_icon-8fb50ae5486891df571071fcb60f93ef.svg";